<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <CreateSystem
        :compatibilityNotes="compatibilityNotes"
        :copyWell="copyWell"
        :showInstallerNotes="true"
        title="Linux"
      >
        <template v-slot:instructions>
          <p>
            To install the agent onto your Linux system, log into the host system as root or sudoer
            and then paste the following command into the terminal window:
          </p>
        </template>
      </CreateSystem>
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { SystemCompatibilityConsts } from 'client/util/Constants';
import CreateSystem from 'client/systems/CreateSystem.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';

export default {
  name: 'CreateLinuxSystem',

  components: {
    CreateSystem,
    DetailsAsideLayout,
  },

  mixins: [
    CreateSystemMixin,
  ],

  computed: {
    compatibilityNotes() {
      return {
        header: 'Supported OS',
        text: SystemCompatibilityConsts.linux,
        kbLink: this.kbLink,
      };
    },

    copyWell() {
      return this.copyWellLinux;
    },
  },
};
</script>
